module.exports = __webpack_public_path__ + "img/sbc_Android.f0ce700c.png";